// スマフォの判定
const $ = require("jquery");
window.$ = $;
window.jQuery = $;

require('./modules/_picturefill')
require('./modules/_script')
require('./modules/_scrollup')
require('./modules/_spMenu')
